import React from "react";

const About = () => {
	return (
		<h1>
			This app has been created
		</h1>
	)
};

export default About;
